
import { CalculatorCategory } from '@/lib/types/calculator.types';

export const financialCategory: CalculatorCategory = {
  id: 'financial-tools',
  name: 'Financial Tools',
  description: 'Financial planning and calculation tools',
  theme: 'finance',
  icon: 'dollar-sign',
  calculators: [
    {
      id: 'mortgage',
      name: 'Mortgage Calculator',
      description: 'Calculate mortgage payments and amortization',
      theme: 'finance'
    },
    {
      id: 'investment',
      name: 'Investment Calculator',
      description: 'Calculate investment returns and growth',
      theme: 'finance'
    },
    {
      id: 'loan',
      name: 'Loan Calculator',
      description: 'Calculate loan payments and interest',
      theme: 'finance'
    },
    {
      id: 'auto-loan',
      name: 'Auto Loan Calculator',
      description: 'Calculate car loan payments',
      theme: 'finance'
    },
    {
      id: 'credit-card-payoff',
      name: 'Credit Card Payoff',
      description: 'Calculate credit card payoff time',
      theme: 'finance'
    },
    {
      id: 'debt-consolidation',
      name: 'Debt Consolidation',
      description: 'Calculate debt consolidation savings',
      theme: 'finance'
    },
    {
      id: 'budget',
      name: 'Budget Calculator',
      description: 'Plan and track your budget',
      theme: 'finance'
    },
    {
      id: 'retirement',
      name: 'Retirement Calculator',
      description: 'Plan for retirement savings',
      theme: 'finance'
    },
    {
      id: 'compound-interest',
      name: 'Compound Interest',
      description: 'Calculate compound interest growth',
      theme: 'finance'
    },
    {
      id: 'inflation',
      name: 'Inflation Calculator',
      description: 'Calculate inflation impact',
      theme: 'finance'
    },
    {
      id: 'portfolio',
      name: 'Portfolio Diversification',
      description: 'Analyze portfolio allocation',
      theme: 'finance'
    },
    {
      id: 'salary',
      name: 'Salary Calculator',
      description: 'Convert between salary formats',
      theme: 'finance'
    },
    {
      id: 'income-tax',
      name: 'Income Tax Calculator',
      description: 'Calculate federal and state taxes',
      theme: 'finance'
    },
    {
      id: 'sales-tax',
      name: 'Sales Tax Calculator',
      description: 'Calculate sales tax amounts',
      theme: 'finance'
    },
    {
      id: 'take-home-pay',
      name: 'Take Home Pay Calculator',
      description: 'Calculate net pay after deductions',
      theme: 'finance'
    }
  ]
};

export default financialCategory;
